import { render, staticRenderFns } from "./CytomineViewer.vue?vue&type=template&id=2cf998d4&scoped=true&"
import script from "./CytomineViewer.vue?vue&type=script&lang=js&"
export * from "./CytomineViewer.vue?vue&type=script&lang=js&"
import style0 from "./CytomineViewer.vue?vue&type=style&index=0&id=2cf998d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf998d4",
  null
  
)

export default component.exports